// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__SoDfw","edit-button":"styles_edit-button__rOIJq","title":"styles_title__pz2QS","buttonsWrapper":"styles_buttonsWrapper__0dvps"};